import {
  SmallBlockIcon,
  SmallShortListIcon,
} from "../../components/atoms/CommonIcon";
import { translate } from "../../helper/common";
import { ACTIVITY_CENTER, SHORTLIST } from "../../routing/routes.constant";

export const TAB_MAP = {
  RECEIVED: {
    route: `${ACTIVITY_CENTER.fullUrl}/received-all`,
  },
  ACCEPTED: {
    route: `${ACTIVITY_CENTER.fullUrl}/accepted-all`,
  },
  SENT: {
    route: `${ACTIVITY_CENTER.fullUrl}/sent-all`,
  },
  DECLINED: {
    route: `${ACTIVITY_CENTER.fullUrl}/declined-all`,
  },
  SHORTLISTED: {
    route: `${ACTIVITY_CENTER.fullUrl}/shortlisted`,
  },
  BLOCKED: {
    route: `${ACTIVITY_CENTER.fullUrl}/blocked-profile`,
  },
};

export const ACTIVITY_SUB_TAB = () => [
  {
    name: translate("Received"),
    route: TAB_MAP.RECEIVED.route,
    type: "RECEIVED",
    action: "ALL",
    id: "received-all",
  },
  {
    name: translate("Accepted"),
    route: TAB_MAP.ACCEPTED.route,
    type: "ACCEPTED",
    action: "ALL",
    id: "accepted-all",
  },
  {
    name: translate("Sent"),
    route: TAB_MAP.SENT.route,
    type: "SENT",
    action: "ALL",
    id: "sent-all",
  },
  {
    name: translate("Declined"),
    route: TAB_MAP.DECLINED.route,
    type: "DECLINED",
    action: "ALL",
    id: "declined-all",
  },
  {
    name: translate("Shortlisted"),
    route: TAB_MAP.SHORTLISTED.route,
    id: "shortlisted",
    action: "GIVE",
    type: "SHORTLISTED",
    isHide: true,
    isDivider: true,
  },
  {
    name: translate("Blocked"),
    route: TAB_MAP.BLOCKED.route,
    action: "GIVE",
    type: "BLOCKED",
    id: "blocked-profile",
    isHide: true,
    isDivider: true,
  },
];

export const MOBILE_TABS = () => [
  {
    name: translate("Shortlisted"),
    description: translate("Manage Your Shortlisted Profiles"),
    icon: <SmallShortListIcon />,
    route: SHORTLIST.fullUrl,
  },
  {
    name: translate("Blocked Contacts"),
    description: translate("Manage and View Blocked Profiles"),
    icon: <SmallBlockIcon />,
    route: `${ACTIVITY_CENTER.fullUrl}/blocked-profile`,
  },
];

export const ENUM = () => {
  return {
    TITLE: translate("Interest"),
    THIS_MIGHT_INTERESTED: translate("This might interest you"),
  };
};
